import React, { useState } from "react"
import {
  Button,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material"

const DownloadButton = ({ activeTab, selectedRow, downloadHandler }: any) => {
  const [open, setOpen] = useState(false)
  const anchorRef = React.useRef<HTMLButtonElement>(null)

  const handleToggle = () => setOpen((prevOpen) => !prevOpen)
  const handleClose = (event: any) => {
    if (anchorRef.current?.contains(event.target)) return
    setOpen(false)
  }
  const handleListKeyDown = (event: any) => {
    if (event.key === "Tab" || event.key === "Escape") {
      setOpen(false)
    }
  }

  return (
    <div>
      <Button
        ref={anchorRef}
        variant="contained"
        onClick={handleToggle}
        sx={{
          fontSize: 11,
          fontWeight: 600,
          textTransform: "none",
          "&:hover": {
            boxShadow: "none", // Disable box shadow (elevation) on hover
          },
        }}
      >
        Download
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        sx={{ zIndex: 10, position: "relative" }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            {/* style={{ transformOrigin: "left top" }} */}
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem
                    disabled={!selectedRow}
                    onClick={(e) => {
                      handleClose(e)
                      downloadHandler(activeTab, "schema")
                    }}
                  >
                    Schema
                  </MenuItem>
                  <MenuItem
                    disabled={!selectedRow}
                    onClick={(e) => {
                      handleClose(e)
                      downloadHandler(activeTab, "raw")
                    }}
                  >
                    Raw Processed
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      handleClose(e)
                      downloadHandler(activeTab, "unique")
                    }}
                  >
                    Unique & Not Null
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}

export default DownloadButton
